import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { FeefoSchema as FeefoSchemaComponent } from '../../../feefoSchema/FeefoSchema';

export const FeefoSchema = () => {
  const data = useStaticQuery(graphql`
    {
      reviews: allUmbracoReviewType {
        nodes {
          reviewDate
          reviewText
          starCount
          title
          customerName
          reviewTag {
            name
          }
        }
      }
    }
  `);

  const filteredReviews = data?.reviews?.nodes
    ?.filter((review) => review.reviewTag?.name === 'General')
    ?.sort((a, b) => new Date(b.reviewDate) - new Date(a.reviewDate));

  return <FeefoSchemaComponent reviews={filteredReviews} />;
};
